// Enums mirrored 1:1 from the Content-Gen API reference. Keep in sync with the backend.

/** AssetKind — the four media families, each with its own generation endpoint. */
export const ASSET_KINDS = ['text', 'audio', 'image', 'video'];

/**
 * Lang — a real asset field; also the suffix on language-bearing type names.
 *  en   → English
 *  hi   → standard Hindi (Devanagari script)
 *  hien → Hinglish — casual Hindi mixed with English words, written in Roman (Latin) script
 *         (e.g. "Matter basically teen states mein hota hai")
 * Video is en/hi only (no hien); images and the two HTML artifacts are language-neutral.
 */
export const LANGS = ['en', 'hi', 'hien'];

/**
 * Scope — which node owns an asset.
 *
 *   paragraph / topic — the ordinary units, addressed by `paragraphId` / `topicId`.
 *   chapter           — the quick-revision set. Owned by the chapter itself, so BOTH `paragraphId`
 *                       and `topicId` are ABSENT and `context` comes back empty; that absence is
 *                       the only thing identifying it. Read `scope` rather than inferring the
 *                       owner from which id happens to be present.
 */
export const SCOPES = ['paragraph', 'topic', 'chapter'];

/** Scope → chip label + the one thing worth knowing about it. */
export const SCOPE_META = {
  paragraph: { label: 'Paragraph', hint: 'Generated for a single paragraph.' },
  topic: { label: 'Topic', hint: 'Generated for a whole section.' },
  chapter: {
    label: 'Chapter',
    hint: 'Quick revision — the chapter seen whole. Not gated by the priority plan: every chapter gets the set.',
  },
};

/** Document lifecycle. */
export const DOCUMENT_STATUS = {
  PENDING: 'pending',
  READY: 'ready',
  FAILED: 'failed',
};

/** Asset lifecycle. */
export const ASSET_STATUS = {
  PENDING: 'pending',
  RUNNING: 'running',
  READY: 'ready',
  FAILED: 'failed',
};

/** Human labels for languages (null / neutral handled at call sites). */
export const LANG_LABELS = {
  en: 'English',
  hi: 'हिन्दी',
  hien: 'Hinglish',
};

/** Short badge codes for languages. */
export const LANG_SHORT = {
  en: 'EN',
  hi: 'HI',
  hien: 'HIN',
};

/**
 * Status → MUI palette colour + label, used by StatusChip for both documents and assets.
 * `running` and `pending` are treated as in-flight (info / warning).
 */
export const STATUS_META = {
  pending: { label: 'Pending', color: 'warning' },
  running: { label: 'Running', color: 'info' },
  ready: { label: 'Ready', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
};

/** Statuses that mean "still working" — drives polling / progress affordances. */
export const IN_FLIGHT_STATUSES = ['pending', 'running'];
